<template>
    <div class="d-flex flex-row p-2 w-100">
        <input
            class="form-control form-control-sm"
            type="search"
            id="search_collections"
            name="search"
            v-model="form.search"
            placeholder="Search Collections"
            aria-label="Search Collections"
            @blur="searchCollection"
            @input="searchCollection"
        >
    </div>
</template>

<script setup>

import { ref } from 'vue';

const emit = defineEmits(['updated:value', 'filtered', 'canceled'])
const props = defineProps(['collections'])

const form = ref({
    search: null,
})

const error = ref(false)

const searchCollection = () => {
    // can be an api request later on. but currently will be using an array to search

    try {
        let filtered = Array.from(props.collections)
                        .filter((collection) => {
                            return collection.name
                                .toString()
                                .toLowerCase()
                                .indexOf(form.value.search.toLowerCase()) >= 0
                        })

        emit('updated:value', filtered)
        emit('filtered', filtered)
    } catch (error) {
        emit('update:value', props.collections)
        emit('filtered', props.collections)
    }
}
</script>
